import { useEffect } from 'react';
import analytics from '../services/analytics';

// Hook to track page views when components mount
export const usePageTracking = (pageName: string) => {
  useEffect(() => {
    analytics.pageView(pageName);
  }, [pageName]);
};